import { getProductCategories } from "../lib/utils-cynos";

const explicitFitFields = ["fit_type", "fitType", "fit", "product_type", "productType", "type"];

const titleCase = (value) => String(value || "")
  .trim()
  .replace(/[_-]+/g, " ")
  .replace(/\s+/g, " ")
  .toLowerCase()
  .replace(/\b\w/g, (char) => char.toUpperCase());

export const getProductFitLabel = (product = {}) => {
  const explicitValue = explicitFitFields
    .map((field) => product[field])
    .find((value) => /oversized|regular|relaxed|slim|boxy/i.test(String(value || "")));

  const source = [
    explicitValue,
    ...getProductCategories(product),
    product.category,
    product.subCategory,
    product.name,
    product.description,
  ].join(" ").toLowerCase();

  if (source.includes("oversized")) return "Oversized Fit";
  if (source.includes("relaxed")) return "Relaxed Fit";
  if (source.includes("slim")) return "Slim Fit";
  if (source.includes("boxy") || source.includes("crop")) return "Boxy Fit";
  if (source.includes("regular")) return "Regular Fit";

  const cleanExplicit = titleCase(explicitValue);
  return cleanExplicit ? `${cleanExplicit} Fit` : "Regular Fit";
};

